import PARENT from '../types';

const SELECTED_STATS = `${PARENT}/SELECTED_STATS`;

export const SET_SELECTED_STATS = `${SELECTED_STATS}/SET`;
export const RESET_SELECTED_STATS = `${SELECTED_STATS}/RESET`;

export const TOGGLE_SELECTED_STATS_VISIBILITY = `${SELECTED_STATS}/TOGGLE_VISIBILITY`;

export default SELECTED_STATS;
